import React from 'react';
import { IAssignment } from '@/components/interfaces';
import Popover, { onOpenAutoFocus } from '@/components/ui/Popover/Popover';
import Icon from '@/components/ui/Icon';
import { PostScoresButton } from '@/components/staffer/Scores/GradesTable/PostScoresButton';
import TrendsAndClearButtons from '@/components/staffer/Scores/GradesTable/Table/Cells/HeaderCell/TrendsAndClearButtons';
import * as Routes from '@/modules/routes';

import useGradesTableStore from '../../store/useGradesTableStore';

const AssignmentOptionsMenu = ({ assignment }: { assignment: IAssignment }) => {
  const programId = useGradesTableStore(state => state.programId);
  const lesson = useGradesTableStore(state => state.lesson);
  const classroom = useGradesTableStore(state => state.classroom);

  const { Assessment = [], Challenge = [] } = assignment.assignment_models_hash;
  const assessment = Assessment[0];
  const challenge = Challenge[0];
  if (!assessment && !challenge) return null;

  const lessonId = lesson?.id ?? assignment.first_lesson_id;

  const clearAssessmentLink = (assessmentId: number) => (
    Routes.reset_classroom_scores_shared_program_lesson_assessment_scores_path(
      programId,
      lessonId,
      { assessment_id: assessmentId, classroom_id: classroom?.id },
    )
  );

  const assessmentTrendsLink = (assessmentId: number) => (
    Routes.teacher_assessment_trend_path(assessmentId, {
      classroom_id: classroom?.id,
      lesson_id: lessonId,
      program_id: programId,
    })
  );

  const clearChallengeUrl = (challengeId: number) => (
    Routes.reset_classroom_scores_teacher_classroom_challenge_scores_path(challengeId, {
      classroom_id: classroom.id,
      lesson_id: lessonId,
    })
  );

  const challengeTrendsUrl = Routes.teacher_reading_challenge_trend_path(lessonId, {
    classroom_id: classroom.id,
    program_id: programId,
  });

  return (
    <Popover>
      <Popover.Trigger
        className={`tw-cursor-pointer tw-bg-none tw-outline-none tw-border-none tw-bg-inherit tw-relative
                    tw-right-1 tw-top-1 tw-text-lg hover:tw-bg-opacity-10 hover:tw-bg-tci-purple tw-px-2`}
      >
        <Icon fill="#777770" icon="MoreMenuVertical" />
      </Popover.Trigger>
      <Popover.Content
        className="tw-w-auto tw-z-[1040]"
        side="top"
        onOpenAutoFocus={onOpenAutoFocus}
      >
        <>
          {assessment && (
            <>
              <TrendsAndClearButtons
                ClearAllButtonProps={{
                  afterReset: () => window.location.reload(),
                  assignmentType: 'assessment',
                  isDisabled: !assignment.can_clear_exercise_results,
                  link: clearAssessmentLink(assessment.id),
                  queryKey: ['ASSESSMENT_EXERCISE_RESULTS', classroom.id, lessonId],
                }}
                TrendsButtonProps={{
                  assignmentType: 'assessment',
                  link: assessmentTrendsLink(assessment.id),
                }}
              />
              <PostScoresButton
                displayIcon
                assessmentId={assessment.id}
                assignmentId={assignment.id}
                classroomId={classroom.id}
                lessonId={lessonId}
                programId={programId}
              />
            </>
          )}

          {challenge && (
            <TrendsAndClearButtons
              ClearAllButtonProps={{
                afterReset: () => window.location.reload(),
                assignmentType: 'lesson game',
                isDisabled: !assignment.can_clear_exercise_results,
                link: clearChallengeUrl(challenge.id),
                queryKey: ['GAME_EXERCISE_RESULTS', classroom?.id, lessonId],
              }}
              TrendsButtonProps={{
                assignmentType: 'lesson game',
                link: challengeTrendsUrl,
              }}
            />
          )}
        </>
      </Popover.Content>
    </Popover>
  );
};

export default AssignmentOptionsMenu;
